(() => {
  const forms = document.querySelectorAll('[data-filter-form], [data-sort-form]');
  const preserveState = form => {
    form.querySelectorAll('[data-preserved-param]').forEach(input => input.remove());
    const owned = new Set([...form.elements].filter(input => input.name && !input.disabled).map(input => input.name));
    const params = new URLSearchParams(window.location.search);
    for (const [name, value] of params) {
      if (name === 'page' || owned.has(name)) continue;
      if (!(name.startsWith('filter.') || ['q', 'type', 'sort_by', 'options[prefix]', 'view'].includes(name))) continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.dataset.preservedParam = '';
      form.append(input);
    }
  };
  forms.forEach(form => {
    preserveState(form);
    form.addEventListener('submit', () => preserveState(form));
    form.addEventListener('change', event => {
      if (!event.target.matches('input[type="checkbox"], select[name="sort_by"]')) return;
      if (form.checkValidity()) form.requestSubmit();
    });
  });
  document.querySelectorAll('[data-filter-disclosure]').forEach(disclosure => {
    const desktop = window.matchMedia('(min-width: 900px)');
    const sync = () => { disclosure.open = desktop.matches; };
    sync();
    desktop.addEventListener('change', sync);
    disclosure.addEventListener('toggle', () => {
      if (desktop.matches && !disclosure.open) disclosure.open = true;
    });
  });
})();
